import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { TransfersOtherBanksService } from '../transfers-other-banks.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TransfersOtherBanksEventType } from '../transfers-other-banks.event.type';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import { CurrentBalanceEventType } from '../../../shared/current-balance/current-balance.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { MatDialog } from '@angular/material';
import { ModalAntifraudWarningComponent } from '../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';
import { TransferSituation } from '../../models/transferSituation';
import { TransactionHandlerService } from '../transfer-response/services/transaction-handler.service';
import { AntifraudeDataModel } from '../transfer-response/models/antifraude-data.model';
import { TransactionResponseStatus } from '../transfer-response/models/transaction-response-status.enum';

@Component({
	selector: 'app-transfer-result',
	templateUrl: './transfer-result.component.html',
	styleUrls: ['./transfer-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferResultComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="transfer-result"]';

	active = false;
	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	showAntifraudScreen: boolean = false;

	public isScheduled: boolean;
	public showExportButtons: boolean;
	antifraudeModel: AntifraudeDataModel;

	constructor(
		private transferOBService: TransfersOtherBanksService,
		private transactionResponseHandler: TransactionHandlerService,
		public dialog: MatDialog) {
	}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT, data => {

			if (!data.show) {
				this.hide();
				return;
			}

			if(!this.awaitingAntifraudAnalysis && !this.antifraudCanceled) {
				this.active = true;
			}

			this.show();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT);
	}

	show() {
		this.isScheduled = this.transferOBService.scheduleSpan;

		if (this.awaitingAntifraudAnalysis) {
			AppEventDispatcher.dispatch(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT, {show: false});
			this.setTitleSubtitle.emit({
				title: 'Importante',
				subtitle: 'Para sua segurança, a transferência abaixo está em análise!',
			});
			this.setDataAntifraudScreen();
			return;
		}

		this.showExportButtons = this.transferData.success;

		this.setTitleSubtitle.emit({
				title: 'Resumo da Transferência para Outros Bancos',
				subtitle: 'Transferência financeira de sua conta para outros Bancos.',
		});

		AppEventDispatcher.dispatch(TransfersOtherBanksEventType.ACTIONS.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
			AppEventDispatcher.dispatch( CurrentBalanceEventType.BALANCE_UPDATE, null);

			AppEventDispatcher.dispatch(EventTypes.EXPORT_BUTTONS.DATA_TRANSACTION, {
				transferNumber: this.transferData.confirmationCode,
				receiptType: this.transferData.transferType
			});
		});
	}

	hide() {
		TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() - 30;
	}

	get awaitingAntifraudAnalysis(): boolean {
		return this.transferData.situation === TransactionResponseStatus.AGUARDANDO_ANALISE_ANTIFRAUDE;
	}


	get antifraudCanceled(): boolean {
		return this.transferData.situation === TransactionResponseStatus.CANCELADA_SUSPEITA_FRAUDE;
	}

	setDataAntifraudScreen(): void {
		this.antifraudeModel = this.transactionResponseHandler.getAntifraudModel();
		this.nameTransfer = this.antifraudeModel.name;
		this.valueTransfer = this.antifraudeModel.value;
		this.dateTransfer = this.antifraudeModel.dateTransaction;
		this.showAntifraudScreen = this.antifraudeModel.showAntifraude;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-result/transfer-result.component.ts